/* RESPONSIBLE TEAM: team-frontend-tech */
let resolveObjectPath = function (obj, path) {
  return path.split('.').reduce(function (prev, curr) {
    return prev ? prev[curr] : null;
  }, obj || self);
};

export default resolveObjectPath;
